if (!customElements.get('keydom-sale-navigation')) {
  customElements.define('keydom-sale-navigation', class extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('header');
      this.template = this.querySelector('template');
      if (!this.header || !this.template) return;
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.header, { childList: true, subtree: true });
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    sync() {
      const menu = this.header.querySelector('.header__icons--right.gm-menu-94139');
      if (!menu) return;
      const arrivals = [...menu.children].find(item =>
        item.querySelector(':scope > a[href$="/collections/new-arrivals"]'));
      if (!arrivals) return;
      let sale = menu.querySelector(':scope > .kd-bf-nav');
      if (!sale) sale = this.template.content.firstElementChild.cloneNode(true);
      if (arrivals.previousElementSibling !== sale) menu.insertBefore(sale, arrivals);
      const brands = [...menu.children].find(item =>
        item.querySelector(':scope > a[href$="/pages/brands"]'));
      brands?.classList.add('kd-nav-brands');
    }
  });
}
